// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2T1H-","visuallyhidden":"_2cKBa","hide-text":"_3lYjU","center":"_1pIp-","noprint":"_3wkUz","root":"_3SPB5","carousel":"_3s-9g","button":"_13TS-","buttonPrevious":"_1UMgR","buttonNext":"_1xb_z","videoSlide":"lv4JE","buttonContent":"_3XsOq","slides":"_1ApC-","statusBar":"wsmgg","caption":"_1nNs-","byline":"_3ujY5","state":"_3rzDP"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-gallery/styles/gallery/feature.scss
 ** module id = 132
 ** module chunks = 2
 **/